// extracted by mini-css-extract-plugin
export default {"infoButton":"ContactlessDeliveryInstructions-module__infoButton___6wMk7"};